import { inputValidFloat } from './validator'
// 保留小数-精度
export function Amount(value, fix = 2, int = true) {
    return Number(inputValidFloat(`${value}`, fix, int))
}

// 保留小数-计算
export function AmountDecimal(value, fix = 2) {
    if (!value) {
        return 0
    }
    if (value === '-' || value === '--') {
        return value
    }
    let num = Number(value)
    let roundNum = Math.pow(100, fix / 2)
    num = Math.round(num * roundNum)
    // num = parseFloat(num / roundNum).toFixed(fix)
    num = String(num / roundNum).replace(/(\.\d{fix})\d+$/, '$1')
    return Number(num)
}

/** 与列表 AmountDecimal(fix) 展示精度一致地比较两单价是否不同；避免「单价×数量再÷数量」的二进制浮点误差误判为改价而显示协议价划线 */
export function danjiaAnXianshiJingduButong(xieyidanjia, caigoudanjia, fix = 6) {
    return AmountDecimal(xieyidanjia, fix) !== AmountDecimal(caigoudanjia, fix)
}


// WEBPACK FOOTER //
// ./src/utils/price.js